/*
The first time the page is loaded, the color mode set on the preference
is used and set as 'default' in the local storage.
Changing the default preferences works the same way as changing the
color mode using the buttons, if the page is loaded.
When the page is reloaded, whatever is the value set on the local storage
has precedence over the values in the preference. If the preference
changed after the page was visited - and the page is not loaded -
the last value saved on the local storage is loaded.
*/

const darkButton = document.getElementById("dark");
const lightButton = document.getElementById("light");

const darkLable = document.getElementById("darklabel");
const lightLable = document.getElementById("lightlabel");

const setDarkMode = () => {
  document.querySelector("body").classList = "dark";
  localStorage.setItem("colorMode", "dark");
  lightLable.classList.add("label--show");
  darkLable.classList.remove("label--show");
};

const setLightMode = () => {
  document.querySelector("body").classList = "light";
  localStorage.setItem("colorMode", "light");
  darkLable.classList.add("label--show");
  lightLable.classList.remove("label--show");
};

const colorModeFromLocalStorage = () => {
  return localStorage.getItem("colorMode");
};

const colorModeFromPreferences = () => {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light"; // If preference is set or does not match anything (light is default)
};

const loadAndUpdateColor = () => {
  // local storage has precendence over the prefers-color-scheme
  const color = colorModeFromLocalStorage() || colorModeFromPreferences();
  color == "dark" ? darkButton.click() : lightButton.click();
};

// when the inputs are clicked, check which radio button is checked and change the color
const radioButtons = document.querySelectorAll(".toggle__wrapper input");
radioButtons.forEach((button) => {
  button.addEventListener("click", (event) => {
    darkButton.checked ? setDarkMode() : setLightMode();
  });
});

// when the prefers-color-scheme changes, this event will be emitted
// event reflects the media query, if it matches, the new color is dark, else it is light
window
  .matchMedia("(prefers-color-scheme: dark)")
  .addEventListener("change", (event) => {
    console.log(7);
    event.matches ? darkButton.click() : lightButton.click();
  });

// Load the right color on startup - localStorage has precedence
loadAndUpdateColor();
